import videojs from 'video.js';

export class IntroPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadIntroOrMainPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    return presentationData.playerOptions.intro.enabled;
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('intro')) {
            const { IntroPlugin } = await import(/* webpackChunkName: 'intro' */ './intro-outro.js');
            player.registerPlugin('intro', IntroPlugin);

            player.intro().enabled = true;
        }
    }
}